import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import FixedView from "../FixedView";
import TextInput from "./TextInput";
import { FormBuilderObjects } from "../../variables/formBuilderData"
import "../../styles/components/inputs.scss"
import { checkTranslation } from "../../utils/useful";

class FieldItem extends Component {
    state = {
        items: [
            // { item: 'Name', src: '/assets/icons/name.svg' },
            // { item: 'Priority', src: '/assets/icons/priority.svg' },
            // { item: 'Flagged', src: '/assets/icons/flagged.svg' },
            // { item: 'Assignee', src: '/assets/icons/assignee.svg' },
            // { item: 'Start date', src: '/assets/icons/calendar.svg' },
            // { item: 'Date', src: '/assets/icons/calendar.svg' }
        ],
        sort: 1,
        slectedCell: {}
    };

    componentDidMount() {
        if (this.props.item?.sortType) {
            this.setState({ sort: this.props.item?.sortType })
        }
        this.setState({ items: this.props.item.information?.label }, () => {
            // console.log('itemsoooooooo',this.state.items);
        });
        let element
        for (let index = 0; index < this.props.default.length; index++) {
            element = this.props.default[index];

        }
        this.setState({ slectedCell: element })
        // console.log('element', element);
    }
    openFirstView = () => {
        this.firstView.showView();
    };

    openSecondView = () => {
        this.secondView.showView();
    };

    change = (value) => {
        this.setState({ sort: value }, () => {
            if (this.props.setSortType) {
                this.props.setSortType(this.props.item?.key, value)
            }
        })
        this.secondView.hideView();
    }

    render() {
        return (
            <div className="" style={{}}>
                <div className="flexc " style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff", }}>
                    <div className="">
                        <div className="sort flexcb p-1" style={{}}>
                            <div className="flexcb px-3 py-1 br-20" style={{ backgroundColor: '#f2f2f2', }} ref={(el) => (this.firstCurrentNode = el)} onClick={() => this.openFirstView()}>
                                <p className="text-smaller" style={{ whiteSpace: 'nowrap' }}>{checkTranslation(this.props.item?.information?.label)}</p>
                                {/* <img className="" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" /> */}
                            </div>

                            <div className=" flexcb p-1" ref={(el) => (this.secondCurrentNode = el)} onClick={() => this.openSecondView()} style={{}}>
                                {(FormBuilderObjects[this.props.type]?.sortType == "text") && (
                                    <div className="flexcc">
                                        {this.state.sort == 1 ? (
                                            <div className="br-20  flexc py-1" style={{}}>
                                                <p className="text-smallest">A</p>
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="8px" />
                                                <p className="text-smallest">Z</p>
                                            </div>
                                        ) : (
                                            <>
                                                <p className="text-smaller">Z</p>
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                                <p className="text-smaller">A</p>
                                            </>
                                        )}
                                    </div>
                                )}
                                {(FormBuilderObjects[this.props.type]?.sortType == "number") && (
                                    <div className="flexcc">
                                        {this.state.sort == 1 ? (
                                            <>
                                                <p className="text-smaller">1</p>
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                                <p className="text-smaller">9</p>
                                            </>
                                        ) : (
                                            <>
                                                <p className="text-smaller">9</p>
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                                <p className="text-smaller">1</p>
                                            </>
                                        )}

                                    </div>
                                )}
                                {FormBuilderObjects[this.props.type]?.sortType == "check" && (
                                    <div className="flexcc">
                                        {this.state.sort == 1 ? (
                                            <>
                                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/square-without-chechmark.svg" width="13px" />
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/checkmark-square.svg" width="13px" />
                                            </>
                                        ) : (
                                            <>
                                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/checkmark-square.svg" width="13px" />
                                                <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/square-without-chechmark.svg" width="13px" />
                                            </>
                                        )}

                                    </div>
                                )}
                                {/* {(this.props.item.information.label == "Tdext" || this.props.item.information.label == "Assignee") && (
                                    <div className="flexcc">
                                        <p className="text-smaller">A</p>
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <p className="text-smaller">Z</p>
                                    </div>
                                )} */}
                                {FormBuilderObjects[this.props.type]?.sortType == "Priority" && (
                                    <div className="flexcc">
                                        <p className="text-smaller">First - Last</p>
                                    </div>
                                )}
                                {/* <img className="" style={{ opacity: 0.8 }} src="/assets/icons/down-arrow.svg" width="10px" /> */}
                            </div>
                        </div>
                    </div>
                </div>

                <FixedView ref={(el) => (this.firstView = el)} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={-10} zIndex={10} width={200}>
                    <div className='scroll-no-scrollbar bg-white br-10 p-1 shadow-3  ' style={{ maxHeight: 300, }} >
                        {this.props.headers.map((item, index) => {
                            // console.log('item.information.label', item.information.label, 'default', this.state.slectedCell);
                            return (
                                <div className="" style={{}}>
                                    <div onClick={() => [this.props.setData(this.props.item, item), this.props.makeList()]} className=" flexcc flex-column hover-gray br-5 sort-box" style={{ display: item.information?.label == this.state.slectedCell?.information?.label ? '' : '', alignItems: "flex-start" }}>
                                        <div className="flexc p-1 my-1" >
                                            <img className="mx-1" style={{ opacity: 0.8 }} src={this.props.src} width="10px" />
                                            <p className="text-smaller">{checkTranslation(item.information?.label)}</p>
                                        </div>

                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </FixedView>

                <FixedView ref={(el) => (this.secondView = el)} nodeRef={this.secondCurrentNode} showFocus={false} topOffset={0} xOffset={-10} zIndex={10} width={70}>
                    <div className='scroll-no-scrollbar bg-white br-10 p-1 shadow-3  ' style={{ maxHeight: 300, }} >
                        <div className="flexcb w-100" style={{}}>
                            {(FormBuilderObjects[this.props.type]?.sortType == "number") && (
                                <div className="w-100 text-center">
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(1)}>
                                        <p className="text-smaller">1</p>
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <p className="text-smaller">9</p>
                                    </div>
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(-1)}>
                                        <p className="text-smaller">9</p>
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <p className="text-smaller">1</p>
                                    </div>
                                </div>
                            )}
                            {FormBuilderObjects[this.props.type]?.sortType == "check" && (
                                <div className="w-100 text-center">
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(1)}>
                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/square-without-chechmark.svg" width="13px" />
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/checkmark-square.svg" width="13px" />
                                    </div>
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(-1)}>
                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/checkmark-square.svg" width="13px" />
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/square-without-chechmark.svg" width="13px" />
                                    </div>
                                </div>
                            )}
                            {(FormBuilderObjects[this.props.type]?.sortType == "text") && (
                                <div className="w-100 text-center">
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(1)}>
                                        <p className="text-smaller">A</p>
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <p className="text-smaller">Z</p>
                                    </div>
                                    <div className="hover-gray br-5 flexcc p-1" onClick={() => this.change(-1)}>
                                        <p className="text-smaller">Z</p>
                                        <img className="mx-1" style={{ opacity: 0.8 }} src="/assets/icons/arrow-right.svg" width="10px" />
                                        <p className="text-smaller">A</p>
                                    </div>
                                </div>
                            )}
                            {this.props.item.information?.label == "Priority" && (
                                <div className="w-100 text-center">
                                    <div className="hover-gray br-5 flexcc p-1">
                                        <p className="text-smaller">First - Last</p>
                                    </div>
                                    <div className="hover-gray br-5 flexcc p-1">
                                        <p className="text-smaller">Last - First</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </FixedView>
            </div>
        );
    }
}

export default FieldItem;
